"use strict";
exports.resourceTypes = {
    mortgage: 'mortgage',
    property: 'property',
    class: 'class',
    customer: 'customer'
};
